import {
  GOOGLE_SSO_ROUTE, MS_SSO_ROUTE,
} from '~/_shared/constants/routes';
import { getBaseUrl } from '~/_shared/utils/url/url.helpers';

export const getMsSsoRedirectUri = (): string =>
  `${getBaseUrl()}${MS_SSO_ROUTE}`;

export const getGoogleSsoRedirectUri = (): string =>
  `${getBaseUrl()}${GOOGLE_SSO_ROUTE}`;
